import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ModalService {
    private modalMap = new Map<string, Subject<any>>();

    createModal(id: string): Observable<any> {
        const subject = new Subject<any>();
        this.modalMap.set(id, subject);
        return subject.asObservable();
    }

    closeModal(id: string, data?: any) {
        const subject = this.modalMap.get(id);
        if (subject) {
            subject.next(data);
            subject.complete();
            this.modalMap.delete(id);
        }
    }
}